module.exports = __webpack_public_path__ + "static/index/img/baikal-301.c9724348.jpg";